// import axios from "axios";
import { getStructuredQueryParam } from "./Common";
import { getRestaurantId } from "./authUtils";
import axios from "./axios";

export default class ApiService {
  constructor() {}

  static getHeader() {
    return {
      "Content-Type": "application/json",
      "x-client-key": process.env.REACT_APP_API_CLIENT_KEY,
      "x-app-client": "web",
      "x-restaurant-id": getRestaurantId(),
    };
  }

  static getAuthHeader(token) {
    return {
      "Content-Type": "application/json",
      "x-client-key": process.env.REACT_APP_API_CLIENT_KEY,
      "x-api-token": token,
      "x-app-client": "web",
      "x-fcm-token": localStorage.getItem("fcmToken"),
      "x-restaurant-id": getRestaurantId(),
    };
  }

  static getMultipartAuthHeader(token) {
    return {
      "Content-Type": "multipart/form-data",
      "x-client-key": process.env.REACT_APP_API_CLIENT_KEY,
      "x-api-token": token,
      "x-app-client": "web",
      "x-restaurant-id": getRestaurantId(),
    };
  }

  static getDownloadHeader(token) {
    return {
      "Content-Type": "application/octet-stream",
      "x-client-key": process.env.REACT_APP_API_CLIENT_KEY,
      "x-api-token": token,
      "x-app-client": "web",
      "x-fcm-token": localStorage.getItem("fcmToken"),
      responseType: "blob",
      "x-restaurant-id": getRestaurantId(),
    };
  }

  // when response type is blob
  static getDownloadConfig(token, contentType = "application/octet-stream") {
    return {
      headers: {
        "Content-Type": contentType,
        "x-client-key": process.env.REACT_APP_API_CLIENT_KEY,
        "x-api-token": token,
        "x-app-client": "web",
        "x-fcm-token": localStorage.getItem("fcmToken"),
        "x-restaurant-id": getRestaurantId(),
      },
      responseType: "blob",
    };
  }

  static async LOGIN(payload) {
    try {
      const headers = this.getHeader();
      const res = await axios.post(process.env.REACT_APP_API_BASE_URL + "/v1/admin/login", payload, { headers });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }
  
  // Download coupons report
   static async GET_DOWNLOAD_REPORT_COUPONS(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const res = await axios.get(
        process.env.REACT_APP_API_BASE_URL + `/v1/admin/report/coupon/download` + query,
        this.getDownloadConfig(token),
      );
      return res;
    } catch (err) {
      console.log(err);
      return err.response;
    }
  }

  static async GET_COUPON_REPORT_LIST(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.get(
        process.env.REACT_APP_API_BASE_URL + `/v1/admin/report/coupon/list` + query,
        { headers },
      );
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async COUPON_DELETE(couponId, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/v1/admin/coupon-management/coupon/${couponId}/delete`,
        { headers },
      );
      return res.data;
    } catch (err) {
      return err.response.data;
    }
  }

  static async GET_COUPON_DETAIL(couponId, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.get(
        process.env.REACT_APP_API_BASE_URL + `/v1/admin/coupon-management/coupon/${couponId}/details`,
        { headers },
      );
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async COUPON_UPSERT(params, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.post(
        process.env.REACT_APP_API_BASE_URL + "/v1/admin/coupon-management/coupon/upsert",
        params,
        {
          headers,
        },
      );
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async GET_COUPON_LIST(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.get(
        process.env.REACT_APP_API_BASE_URL + `/v1/admin/coupon-management/coupon/list` + query,
        {
          headers,
        },
      );
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async SALES_SUMMARY_PRINT(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.get(process.env.REACT_APP_API_BASE_URL + "/v1/admin/sales/summary-print" + query, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response.data;
    }
  }

  static async TABLEMANAGEMENT_TABLE_AND_STAFF_UNASSIGN(params, token = "") {
    try {
      const reqBody = { ...params };
      const headers = this.getAuthHeader(token);
      const url = `${process.env.REACT_APP_API_BASE_URL}/v1/admin/table-management/table-and-staff/unassign`;

      const { data } = await axios.patch(url, reqBody, { headers });
      return data;
    } catch (error) {
      return error?.response?.data || { message: "An error occurred while adding membership" };
    }
  }

  static async TABLEMANAGEMENT_TABLE_AND_STAFF_ASSIGN(params, token = "") {
    try {
      const reqBody = { ...params };
      const headers = this.getAuthHeader(token);
      const url = `${process.env.REACT_APP_API_BASE_URL}/v1/admin/table-management/table-and-staff/assign`;

      const { data } = await axios.post(url, reqBody, { headers });
      return data;
    } catch (error) {
      return error?.response?.data || { message: "An error occurred while adding membership" };
    }
  }

  static async GET_TABLEMANAGEMENT_FLOOR_AND_TABLE(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);

      const res = await axios.get(
        process.env.REACT_APP_API_BASE_URL + `/v1/admin/table-management/floor-and-table/get` + query,
        {
          headers,
        },
      );
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async GET_TABLEMANAGEMENT_STAFF_DROPDOWN(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);

      const res = await axios.get(
        process.env.REACT_APP_API_BASE_URL + `/v1/admin/table-management/staff/dropdown` + query,
        {
          headers,
        },
      );
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async TABLEMANAGEMENT_FLOOR_DELETE(params, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.delete(process.env.REACT_APP_API_BASE_URL + `/v1/admin/table-management/floor/delete`, {
        headers: { ...headers },
        data: { ...params },
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async GET_TABLEMANAGEMENT_FLOOR_DROPDOWN(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);

      const res = await axios.get(
        process.env.REACT_APP_API_BASE_URL + `/v1/admin/table-management/floor/dropdown` + query,
        {
          headers,
        },
      );
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async GET_TABLE_AND_STAFF_LIST(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);

      const res = await axios.get(
        process.env.REACT_APP_API_BASE_URL + `/v1/admin/table-management/table-and-staff/list` + query,
        {
          headers,
        },
      );
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async GET_DOWNLOAD_STOCK_REPORT(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const res = await axios.get(
        process.env.REACT_APP_API_BASE_URL + `/v1/admin/inventory/report/download` + query,
        this.getDownloadConfig(token),
      );
      return res;
    } catch (err) {
      return err.response;
    }
  }

  static async GET_DOWNLOAD_PURCHASE_REPORT(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const res = await axios.get(
        process.env.REACT_APP_API_BASE_URL + `/v1/admin/inventory/purchase/report/download` + query,
        this.getDownloadConfig(token),
      );
      return res;
    } catch (err) {
      return err.response;
    }
  }

  static async INVENTORY_PURCHASE_REPORT_SUMMATION(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.get(
        process.env.REACT_APP_API_BASE_URL + `/v1/admin/inventory/purchase/report/summation` + query,
        { headers },
      );
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async INVENTORY_RECIPE_UPSERT(params, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.post(process.env.REACT_APP_API_BASE_URL + "/v1/admin/inventory/recipe/upsert", params, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async GET_ADMIN_PROFILE(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.get(process.env.REACT_APP_API_BASE_URL + `/v1/admin/profile` + query, { headers });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async GET_RESTAURANT_INFO(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.get(process.env.REACT_APP_API_BASE_URL + `/v1/common/restaurant-info` + query, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async SWITCH_BRANCH(params, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.patch(process.env.REACT_APP_API_BASE_URL + `/v1/admin/switch-branch`, params, {
        headers,
      });

      return res.data;
    } catch (err) {
      return err.response.data;
    }
  }

  static async INVENTORY_RECIPE_STATUS_CHANGE_CONFIRM(params, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.patch(
        process.env.REACT_APP_API_BASE_URL + `/v1/admin/inventory/recipe/status/change/confirm`,
        params,
        { headers },
      );

      return res.data;
    } catch (err) {
      return err.response.data;
    }
  }

  static async INVENTORY_RECIPE_STATUS_CHANGE(params, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.patch(
        process.env.REACT_APP_API_BASE_URL + `/v1/admin/inventory/recipe/status/change`,
        params,
        { headers },
      );

      return res.data;
    } catch (err) {
      return err.response.data;
    }
  }

  static async GET_INVENTORY_ADDONS_DROPDOWN(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.get(
        process.env.REACT_APP_API_BASE_URL + `/v1/admin/inventory/add-ons/dropdown/list` + query,
        { headers },
      );
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async INVENTORY_RECIPE_DELETE_CONFIRM(params, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.delete(process.env.REACT_APP_API_BASE_URL + `/v1/admin/inventory/recipe/delete/confirm`, {
        headers: { ...headers },
        data: { ...params },
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async INVENTORY_RECIPE_DELETE(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.delete(process.env.REACT_APP_API_BASE_URL + `/v1/admin/inventory/recipe/delete` + query, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async GET_INVENTORY_RECIPE_DETAIL(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.get(process.env.REACT_APP_API_BASE_URL + `/v1/admin/inventory/recipe/details` + query, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async GET_INVENTORY_RECIPE_LIST(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.get(process.env.REACT_APP_API_BASE_URL + `/v1/admin/inventory/recipe/list` + query, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async GET_INVENTORY_WASTAGE_LIST(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.get(process.env.REACT_APP_API_BASE_URL + `/v1/admin/inventory/wastage/list` + query, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async GET_INVENTORY_REPORT(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.get(process.env.REACT_APP_API_BASE_URL + `/v1/admin/inventory/report` + query, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async INVENTORY_PURCHASE_ITEM_DELETE(purchaseItemId, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/v1/admin/inventory/purchase/${purchaseItemId}/delete`,
        { headers },
      );
      return res.data;
    } catch (err) {
      return err.response.data;
    }
  }

  static async INVENTORY_WASTAGE_ITEM_DELETE(wastageId, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/v1/admin/inventory/wastage/delete/?wastageId=${wastageId}`,
        { headers },
      );
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async INVENTORY_PURCHASE_ITEMS_CREATE(params, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/v1/admin/inventory/purchase/create`, params, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async INVENTORY_READY_FOOD_STOCK_ADD(params, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/v1/admin/inventory/ready-food/stock`, params, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response?.data || {message: 'Unknown error'};
    }
  }

  static async GET_INVENTORY_SUPPLIER_DROPDOWN(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.get(
        process.env.REACT_APP_API_BASE_URL + `/v1/admin/inventory/supplier/dropdown/list` + query,
        { headers },
      );
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async GET_INVENTORY_INGREDIENT_DROPDOWN(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.get(
        process.env.REACT_APP_API_BASE_URL + `/v1/admin/inventory/ingredient/dropdown/list` + query,
        { headers },
      );
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async GET_INVENTORY_FOOD_ITEM_DROPDOWN(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.get(
        process.env.REACT_APP_API_BASE_URL + `/v1/admin/inventory/food/dropdown/list` + query,
        { headers },
      );
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async GET_INVENTORY_ADONS_ITEM_DROPDOWN(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.get(
        process.env.REACT_APP_API_BASE_URL + `/v1/admin/inventory/add-ons/dropdown/list` + query,
        { headers },
      );
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async INVENTORY_WASTAGE_ADD(params, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/v1/admin/inventory/wastage/add`, params, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async GET_INVENTORY_PURCHASE_ITEMS_REPORT(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.get(process.env.REACT_APP_API_BASE_URL + `/v1/admin/inventory/purchase/report` + query, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async INVENTORY_SUPPLIER_DETAIL_WITH_ID(supplierId, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.get(
        process.env.REACT_APP_API_BASE_URL + `/v1/admin/inventory/supplier/${supplierId}/details`,
        { headers },
      );
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async INVENTORY_SUPPLIER_UPSERT(params, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/v1/admin/inventory/supplier/upsert`, params, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async INVENTORY_SUPPLIER_DELETE(supplierId, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/v1/admin/inventory/supplier/${supplierId}/delete`,
        { headers },
      );
      return res.data;
    } catch (err) {
      return err.response.data;
    }
  }

  static async GET_INVENTORY_SUPPLIER_LIST(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.get(process.env.REACT_APP_API_BASE_URL + `/v1/admin/inventory/supplier/list` + query, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async INVENTORY_INGREDIENT_DELETE(ingredientId, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/v1/admin/inventory/ingredient/${ingredientId}/delete`,
        { headers },
      );
      return res.data;
    } catch (err) {
      return err.response.data;
    }
  }

  static async INVENTORY_INGREDIENT_DETAIL_WITH_ID(ingredientId, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.get(
        process.env.REACT_APP_API_BASE_URL + `/v1/admin/inventory/ingredient/${ingredientId}/details`,
        { headers },
      );
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async INVENTORY_INGREDIENT_UPSERT(params, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/v1/admin/inventory/ingredient/upsert`,
        params,
        {
          headers,
        },
      );
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async GET_INVENTORY_INGREDIENT_LIST(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.get(process.env.REACT_APP_API_BASE_URL + `/v1/admin/inventory/ingredient/list` + query, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async GET_INVENTORY_FINAL_REPORT(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);

      const res = await axios.get(process.env.REACT_APP_API_BASE_URL + `/v1/admin/inventory/final-report` + query, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async ORDER_ARCHIVED_WITH_DATE(params, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.post(process.env.REACT_APP_API_BASE_URL + "/v1/admin/order/archive", params, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async GET_SALES_REPORT_SUMMATION(reqBody, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.post(process.env.REACT_APP_API_BASE_URL + `/v1/admin/report/sales/summation`, reqBody, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async GET_SALES_REPORT_LIST(reqBody, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.post(process.env.REACT_APP_API_BASE_URL + `/v1/admin/report/sales/list`, reqBody, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async GET_ITEM_WISE_SALES_REPORT_LIST(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.get(
        process.env.REACT_APP_API_BASE_URL + `/v1/admin/report/item-wise-sales/list` + query,
        { headers },
      );
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async GET_SALES_REPORT_SUMMARY(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.get(process.env.REACT_APP_API_BASE_URL + `/v1/admin/report/sales/summary` + query, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async GET_REFUNDCANCEL_REPORT_SUMMARY(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.get(
        process.env.REACT_APP_API_BASE_URL + `/v1/admin/report/refund-and-cancellation/summary` + query,
        { headers },
      );
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async GET_REFUNDCANCEL_REPORT_LIST(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.get(
        process.env.REACT_APP_API_BASE_URL + `/v1/admin/report/refund-and-cancellation/list` + query,
        { headers },
      );
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async GET_CUSTOMER_REPORT_SUMMARY(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.get(process.env.REACT_APP_API_BASE_URL + `/v1/admin/report/customer/summary` + query, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async GET_CUSTOMER_REPORT_LIST(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.get(process.env.REACT_APP_API_BASE_URL + `/v1/admin/report/customer/list` + query, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async GET_ORDER_REPORT_SUMMARY(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.get(process.env.REACT_APP_API_BASE_URL + `/v1/admin/report/order/summary` + query, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async GET_ORDER_REPORT_LIST(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.get(process.env.REACT_APP_API_BASE_URL + `/v1/admin/report/order/list` + query, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async GET_REPORT_ORDER_DETAIL(id, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.get(process.env.REACT_APP_API_BASE_URL + `/v1/admin/report/order/${id}/details`, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  // Download sales report
  static async GET_DOWNLOAD_REPORT_SALES(reqBody, token = "") {
    try {
      const res = await axios.post(
        process.env.REACT_APP_API_BASE_URL + `/v1/admin/report/sales/download`,
        reqBody,
        this.getDownloadConfig(token, "application/json"),
      );
      return res;
    } catch (err) {
      return err.response;
    }
  }

  static async GET_DOWNLOAD_REPORT_ITEM_WISE_SALES(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const res = await axios.get(
        process.env.REACT_APP_API_BASE_URL + `/v1/admin/report/item-wise-sales/download` + query,
        this.getDownloadConfig(token),
      );
      return res;
    } catch (err) {
      console.log(err);
      return err.response;
    }
  }

  static async GET_DOWNLOAD_REPORT_REFUND_AND_CANCELATION(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const res = await axios.get(
        process.env.REACT_APP_API_BASE_URL + `/v1/admin/report/refund-and-cancellation/download` + query,
        this.getDownloadConfig(token),
      );
      return res;
    } catch (err) {
      console.log(err);
      return err.response;
    }
  }

  static async GET_DOWNLOAD_CUSTOMERS(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const res = await axios.get(
        process.env.REACT_APP_API_BASE_URL + `/v1/admin/report/customer/download` + query,
        this.getDownloadConfig(token),
      );
      return res;
    } catch (err) {
      console.log(err);
      return err.response;
    }
  }

  static async GET_DOWNLOAD_ORDERS_REPORT(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const res = await axios.get(
        process.env.REACT_APP_API_BASE_URL + `/v1/admin/report/order/download` + query,
        this.getDownloadConfig(token),
      );
      return res;
    } catch (err) {
      console.log(err);
      return err.response;
    }
  }

  // Download sales report
  static async GET_DOWNLOADABLE_FINAL_REPORT(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const res = await axios.get(
        process.env.REACT_APP_API_BASE_URL + `/v1/admin/inventory/final-report/download` + query,
        this.getDownloadConfig(token),
      );
      return res;
    } catch (err) {
      return err.response;
    }
  }

  static async UPDATE_BRANCH(params, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.patch(
        process.env.REACT_APP_API_BASE_URL + `/v1/admin/restaurants/branches/${params.branchId}/edit`,
        params.data,
        { headers },
      );

      return res.data;
    } catch (err) {
      return err.response.data;
    }
  }

  static async GET_BRANCH_WITH_ID(branchId, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.get(
        process.env.REACT_APP_API_BASE_URL + `/v1/admin/restaurants/branches/${branchId}/details`,
        { headers },
      );
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async RESTAURANT_BRANCH_CREATE(params, token = "") {
    try {
      const headers = this.getMultipartAuthHeader(token);
      const res = await axios.post(
        process.env.REACT_APP_API_BASE_URL + "/v1/super-admin/restaurants/branches/create",
        params,
        {
          headers,
        },
      );
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async UPDATE_RESTAURANT(params, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.patch(
        process.env.REACT_APP_API_BASE_URL + `/v1/super-admin/restaurants/${params.restaurantId}/edit`,
        params.data,
        { headers },
      );
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async GET_RESTAURANT_BRANCHES(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.get(process.env.REACT_APP_API_BASE_URL + `/v1/super-admin/restaurants/branches` + query, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async GET_RESTAURANT_WITH_ID(id, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.get(process.env.REACT_APP_API_BASE_URL + `/v1/super-admin/restaurants/${id}/details`, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async RESTAURANT_CREATE(params, token = "") {
    try {
      const headers = this.getMultipartAuthHeader(token);
      const res = await axios.post(process.env.REACT_APP_API_BASE_URL + "/v1/super-admin/restaurants/create", params, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async GET_RESTAURANTS(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.get(process.env.REACT_APP_API_BASE_URL + "/v1/super-admin/restaurants" + query, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async GET_RESTAURANT_DROPDOWN(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.get(process.env.REACT_APP_API_BASE_URL + "/v1/common/restaurant/list" + query, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async RESTAURANT_LIST(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.get(process.env.REACT_APP_API_BASE_URL + "/v1/super-admin/restaurants" + query, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async CATEGORY_LIST(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.get(process.env.REACT_APP_API_BASE_URL + "/v1/common/category/list" + query, { headers });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async FILTER_CATEGORY_LIST(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.post(
        process.env.REACT_APP_API_BASE_URL + "/v1/admin/category/filter" + query,
        {},
        { headers },
      );
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async GET_CATEGORY(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getMultipartAuthHeader(token);
      const res = await axios.get(process.env.REACT_APP_API_BASE_URL + "/v1/admin/categories" + query, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async GET_SPECIFIC_CATEGORY_DETAILS({ categoryId, restaurantId }, token = "") {
    try {
      let query = getStructuredQueryParam({ restaurantId });
      const headers = this.getMultipartAuthHeader(token);

      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/v1/admin/categories/${categoryId}${query}`, {
        headers,
      });

      return res.data;
    } catch (err) {
      console.error("Error fetching category details:", err);
      return err.response?.data || { error: "An unexpected error occurred" };
    }
  }

  static async GET_CATEGORY_SUGGESTION(params, token = "") {
    try {
      const headers = this.getMultipartAuthHeader(token);
      const res = await axios.get(process.env.REACT_APP_API_BASE_URL + "/v1/admin/categories/auto-suggestions", {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async UPSERT_CATEGORY(params, token = "") {
    try {
      // Set up headers
      const headers = this.getMultipartAuthHeader(token);

      // Send the request
      const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/v1/admin/categories/upsert`, params, {
        headers,
      });

      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async FILTER_GROUP_LIST(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.get(process.env.REACT_APP_API_BASE_URL + "/v1/super-admin/groups/" + query, { headers });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async ADD_GROUP(params, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.post(process.env.REACT_APP_API_BASE_URL + "/v1/super-admin/groups", params, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async DELETE_GROUP(groupId, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.delete(process.env.REACT_APP_API_BASE_URL + "/v1/super-admin/groups/" + groupId, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async DASHBOARD_SUMMARY(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.get(process.env.REACT_APP_API_BASE_URL + "/v1/admin/summary" + query, { headers });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async LOGOUT(payload, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.post(process.env.REACT_APP_API_BASE_URL + "/v1/admin/logout", payload, { headers });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async FILTER_ORDER_LIST(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/v2/admin/order/list${query}`, { headers });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async ORDER_LIST_SUPER_ADMIN(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/v1/super-admin/sales/orders${query}`, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async FOOD_SET_MENU_LIST(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/v1/admin/food-and-set-menu/list${query}`, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async FILTER_FOOD_LIST(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/v1/admin/food/filter${query}`,
        {},
        { headers },
      );
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async GET_ADMIN_SET_MENU_FILTER(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/v1/admin/set-menu/filter${query}`, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  // Function to fetch food details
  static async GET_FOOD_DETAILS(params, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/v1/admin/food/details?foodId=${params}`,
        {}, // Empty body as required
        { headers },
      );
      return res.data;
    } catch (err) {
      console.error("Error fetching food details:", err);
      return err.response || { error: "Request failed" };
    }
  }

  static async GET_FOOD_STOCK_LIST(params, token = "") {
    try {
      let query = getStructuredQueryParam(params); // Build query from params
      const headers = this.getAuthHeader(token);

      // Make the GET request with the required headers
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/v1/admin/foods/stocks${query}`, { headers });

      return res.data;
    } catch (err) {
      // Handle errors and log them
      console.error("Error in GET_FOOD_STOCK_LIST:", err.response || err);
      return err.response;
    }
  }

  static async PATCH_FOOD_STOCK_LIST(body, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.patch(
        `${process.env.REACT_APP_API_BASE_URL}/v1/admin/foods/stocks`,
        body, // Send the payload as the request body
        { headers },
      );
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async ORDER_STATUS_CHANGE(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/v2/admin/order/status/change${query}`,
        {},
        { headers },
      );
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async UPSERT_ORDER(params, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.post(process.env.REACT_APP_API_BASE_URL + "/v2/admin/order/upsert", params, { headers });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async UPDATE_PAID_ORDER(params, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.post(
        process.env.REACT_APP_API_BASE_URL + "/v1/admin/order/edit-discounted-order",
        params,
        { headers },
      );
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async FOOD_STATUS_CHANGE(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/v1/admin/food/status/change${query}`,
        {},
        { headers },
      );
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async PATCH_ADMIN_SET_MENUS_STATUS_CHANGE(params, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.patch(process.env.REACT_APP_API_BASE_URL + "/v1/admin/set-menus/status/change", params, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async FILTER_STUFF_LIST(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/v1/admin/staff/filter${query}`,
        {},
        { headers },
      );
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async STAFF_STATUS_CHANGE(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/v1/admin/staff/status/change${query}`,
        {},
        { headers },
      );
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async STAFF_BRANCH_CHANGE(params, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.patch(`${process.env.REACT_APP_API_BASE_URL}/v1/admin/staff/update-branches`, params, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async ADMIN_FILE_DELETE(params, token = "") {
    params = Object.assign(
      {
        context: "RESTAURANT_EDIT",
      },
      params,
    );

    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/v1/admin/file/delete`, {
        data: { ...params },
        headers: { ...headers },
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async ORDER_DISCOUNT(params, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.post(process.env.REACT_APP_API_BASE_URL + "/v2/admin/order/discount", params, {
        headers,
      });
      return res.data;
    } catch (err) {
      console.log("----ORDER_PAYMENT---", { err, "err.response.data": err.response.data });
      return err.response.data;
    }
  }

  static async ORDER_PAYMENT(params, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.post(
        process.env.REACT_APP_API_BASE_URL + "/v2/admin/order/discount-and-payment",
        params,
        { headers },
      );
      return res.data;
    } catch (err) {
      console.log("----ORDER_PAYMENT---", { err, "err.response.data": err.response.data });
      return err.response.data;
    }
  }

  static async ORDER_PAYMENT_REFUND(params, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.post(process.env.REACT_APP_API_BASE_URL + "/v1/admin/order/refund-due-clear", params, {
        headers,
      });
      return res.data;
    } catch (err) {
      console.log("----ORDER_PAYMENT_REFUND---", { err, "err.response.data": err.response.data });
      return err.response.data;
    }
  }

  static async ADD_STAFF(params, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.post(process.env.REACT_APP_API_BASE_URL + "/v1/admin/staff", params, { headers });
      return res.data;
    } catch (err) {
      return err.response.data;
    }
  }

  static async PATCH_ADMIN_STAFF(params, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.patch(process.env.REACT_APP_API_BASE_URL + "/v1/admin/staff", params, { headers });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async ADD_RESTAURANT_USER(params, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.post(process.env.REACT_APP_API_BASE_URL + "/v1/super-admin/restaurants/users", params, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async GET_STAFF_DETAILS(params, token = "") {
    try {
      const query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/v1/admin/staff/details${query}`,
        {},
        { headers },
      );
      return res.data;
    } catch (err) {
      console.error(err);
      return err.response;
    }
  }

  static async MARK_AS_READ_NOTIFICATION(id, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/v1/admin/notification/${id}/mark-as-read`, {
        headers,
      });
      return res.data.code === 200;
    } catch (err) {
      console.error("Error while mark notification as read. Error: ", err);
      return false;
    }
  }

  // Notification List
  static async NOTIFICATION_LIST(params, token = "") {
    try {
      const query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/v1/admin/notification/list${query}`, {
        headers,
      });
      if (res.data && res.data.status === "ok" && res.data.code === 200) {
        return res.data;
      } else {
        throw new Error(res.data.message || "Failed to fetch notifications");
      }
    } catch (err) {
      console.error("Notification fetch error:", err);
      return {
        error: true,
        message: err.response?.data?.message || err.message,
      };
    }
  }

  static async PAYMENT_SUMMARY(params, token = "") {
    try {
      const query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/v1/admin/payment/summary${query}`, {
        headers,
      });
      if (res.data && res.data.status === "ok" && res.data.code === 200) {
        return res.data;
      } else {
        throw new Error(res.data.message || "Failed to fetch payment summary");
      }
    } catch (err) {
      console.error("Payment Summary fetch error:", err);
      return {
        error: true,
        message: err.response?.data?.message || err.message,
      };
    }
  }

  static async ADD_FOOD(params, token = "") {
    try {
      const headers = this.getAuthHeader(token); // Get the authentication headers
      const res = await axios.post(process.env.REACT_APP_API_BASE_URL + "/v1/admin/food", params, { headers }); // API request to add food
      return res.data; // Return the response data
    } catch (err) {
      return err.response; // Return error response if the request fails
    }
  }

  static async GET_CATEGORY_DETAILS(params, token = "") {
    try {
      const query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/v1/admin/category/details${query}`,
        {},
        { headers },
      );
      if (res.data && res.data.status === "ok" && res.data.code === 200) {
        return res.data;
      } else {
        throw new Error(res.data.message || "Failed to fetch category details");
      }
    } catch (err) {
      return err.response; // Return error response if the request fails
    }
  }

  static async CATEGORY_STATUS_CHANGE(params, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.patch(`${process.env.REACT_APP_API_BASE_URL}/v1/admin/categories/status-change`, params, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async CATEGORY_DELETE(restaurantId, categoryId, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/v1/admin/categories/${categoryId}?restaurantId=${restaurantId}`,
        { headers },
      );
      return res.data;
    } catch (err) {
      return err.response.data;
    }
  }

  static async CATEGORY_DELETE_WITH_DEPENDENCIES(data, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/v1/admin/categories/delete/confirm`, {
        data,
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response.data;
    }
  }

  static async GET_RESTAURANT(params, token = "") {
    try {
      const query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/super-admin/groups/restaurants${query}`,
        { headers }, // Correctly include headers as the second argument
      );

      if (res.data && res.data.status === "ok" && res.data.code === 200) {
        return res.data;
      } else {
        throw new Error(res.data.message || "Failed to fetch category details");
      }
    } catch (err) {
      return err.response; // Return error response if the request fails
    }
  }

  static async FORGOT_PASSWORD(params) {
    try {
      const headers = this.getHeader();
      const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/v1/admin/forgot-password`, params, {
        headers,
      });

      return res.data;
    } catch (err) {
      return err.response?.data;
    }
  }

  static async VERIFY_OTP(params) {
    try {
      const headers = this.getHeader();
      const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/v1/admin/verify/otp`, params, { headers });
      if (res.data && res.data.status === "ok" && res.data.code === 200) {
        return res.data;
      } else {
        throw new Error(res.data.message || "Failed to fetch payment summary");
      }
    } catch (err) {
      return {
        error: true,
        message: err.response?.data?.message || err.message,
      };
    }
  }

  static async CHANGE_PASSWORD(params, token = "") {
    try {
      const headers = this.getAuthHeader(token);

      const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/v1/admin/change/password`, params, {
        headers,
      });

      if (res.data && res.data.status === "ok" && res.data.code === 200) {
        return res.data; // Return the success data if password change was successful
      } else {
        throw new Error(res.data.message || "Failed to change password");
      }
    } catch (err) {
      // Return an error object with the message from the server response or the error message
      return {
        error: true,
        message: err.response?.data?.message || err.message,
      };
    }
  }

  static async NEW_PASSWORD_SET(params) {
    try {
      const headers = this.getHeader();
      const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/v1/admin/set/new-password`, params, {
        headers,
      });
      if (res.data && res.data.status === "ok" && res.data.code === 200) {
        return res.data;
      } else {
        throw new Error(res.data.message || "Failed to fetch payment summary");
      }
    } catch (err) {
      return {
        error: true,
        message: err.response?.data?.message || err.message,
      };
    }
  }

  static async FOOD_UPSERT(params, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.post(process.env.REACT_APP_API_BASE_URL + "/v1/admin/foods/upsert", params, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  // static async ADD_FOODS_WITH_IMAGE(params, token = "") {
  //   try {
  //     const headers = this.getAuthHeader(token);
  //     const res = await axios.post(
  //       process.env.REACT_APP_API_BASE_URL + "/v1/admin/foods",
  //       params,
  //       {
  //         headers,
  //       }
  //     );
  //     return res.data;
  //   } catch (err) {
  //     return err.response;
  //   }
  // }

  // static async PATCH_FOODS_WITH_IMAGE(foodId, params, token = "") {
  //   try {
  //     const headers = this.getAuthHeader(token);
  //     const res = await axios.patch(
  //       process.env.REACT_APP_API_BASE_URL + `/v1/admin/foods/${foodId}/edit`,
  //       params,
  //       {
  //         headers,
  //       }
  //     );
  //     return res.data;
  //   } catch (err) {
  //     return err.response;
  //   }
  // }

  // Function to add set menu
  static async ADD_SET_FOODS(params, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.post(process.env.REACT_APP_API_BASE_URL + "/v1/admin/set-menus", params, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  // Function to fetch food details
  static async GET_SET_MENU_DETAILS(setMenuId, token = "") {
    try {
      const headers = this.getMultipartAuthHeader(token);

      // Make the GET request with the categoryId in the URL path
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/v1/admin/set-menus/${setMenuId}`, {
        headers,
      });

      return res.data;
    } catch (err) {
      console.error("Error fetching category details:", err);
      return err.response?.data || { error: "An unexpected error occurred" };
    }
  }

  static async UPDATE_PAYMENT_METHOD(params, token = "") {
    try {
      const headers = this.getAuthHeader(token);

      // Send the request with params in the body
      const res = await axios.patch(
        process.env.REACT_APP_API_BASE_URL + "/v1/admin/restaurant/settings",
        {
          ...params, // Request body should include the params
        },
        {
          headers,
        },
      );
      return res.data;
    } catch (err) {
      return err.response.data;
    }
  }

  static async REGISTER_DEVICE_TOKEN(fcmToken, token = "") {
    try {
      localStorage.setItem("fcmToken", fcmToken);
      const headers = this.getAuthHeader(token);
      const res = await axios.get(process.env.REACT_APP_API_BASE_URL + "/v1/admin/refresh-fcm-token", { headers });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async FETCH_ORDER_DETAILS(orderId, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.get(process.env.REACT_APP_API_BASE_URL + `/v2/admin/order/${orderId}/details`, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async GET_TRENDING_FOODS(params, token = "") {
    try {
      const query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.get(process.env.REACT_APP_API_BASE_URL + `/v1/admin/trending-foods${query}`, { headers });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async GET_USER_LIST(params, token = "") {
    try {
      const query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);

      const res = await axios.get(process.env.REACT_APP_API_BASE_URL + `/v1/super-admin/restaurants/users${query}`, {
        headers,
      });

      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async POST_ADMIN_ORDER_REFUND(params, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.post(process.env.REACT_APP_API_BASE_URL + "/v1/admin/order/refund", params, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async DELETE_RESTAURANT_USER(params, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.post(
        process.env.REACT_APP_API_BASE_URL + "/v1/super-admin/restaurants/user/delete",
        params,
        {
          headers,
        },
      );
      return res.data;
    } catch (error) {
      return error.response;
    }
  }

  static async EDIT_RESTAURANT_USER(params, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.patch(
        process.env.REACT_APP_API_BASE_URL + "/v1/super-admin/restaurants/users/edit",
        params,
        {
          headers,
        },
      );
      return res.data;
    } catch (error) {
      return error.response;
    }
  }

  static async SEND_BLUETOOTH_DEVICE_SCAN_REQ(reqBody, token = "") {
    try {
      const headers = this.getAuthHeader(token);

      // get device id from state as localstorage
      let deviceId = "";
      const generalStorage = localStorage.getItem("general-storage");

      if (generalStorage) {
        const tmp = JSON.parse(generalStorage);
        deviceId = tmp.state.deviceId;
      }

      const payload = { ...reqBody, deviceId };

      // Send the request with params in the body
      const res = await axios.post(
        process.env.REACT_APP_API_BASE_URL + "/v1/admin/print-service/scan-bluetooth-devices",
        payload,
        {
          headers,
        },
      );
      return res.data;
    } catch (err) {
      return err.response.data;
    }
  }

  static async SEND_PRINT_TEST_REQUEST(reqBody, token = "") {
    try {
      const headers = this.getAuthHeader(token);

      // Send the request with params in the body
      const res = await axios.post(
        process.env.REACT_APP_API_BASE_URL + "/v1/admin/print-service/auto-print-test",
        reqBody,
        {
          headers,
        },
      );
      return res.data;
    } catch (err) {
      return err.response.data;
    }
  }

  /**
   * For auto print command request payload should contain orderId
   * For manual request paylaod should contain orderId, printPurpose and device id
   *
   * @param {*} reqBody
   * @param {*} token
   * @param {*} isManual
   * @returns
   */
  static async SEND_PRINT_REQUEST(reqBody, token = "", isManual = false) {
    try {
      const headers = this.getAuthHeader(token);
      const apiPath = isManual
        ? "/v2/admin/print-service/manual-print-command"
        : "/v2/admin/print-service/auto-print-command";
      // Send the request with params in the body
      const res = await axios.post(process.env.REACT_APP_API_BASE_URL + apiPath, reqBody, {
        headers,
      });
      return res.data;
    } catch (err) {
      return err.response.data;
    }
  }

  static async UPDATE_PRINTER_SETTINGS(params, token = "") {
    try {
      const headers = this.getAuthHeader(token);

      // Send the request with params in the body
      const res = await axios.patch(
        process.env.REACT_APP_API_BASE_URL + "/v1/admin/print-service/printer-settings",
        {
          ...params, // Request body should include the params
        },
        {
          headers,
        },
      );
      return res.data;
    } catch (err) {
      return err.response.data;
    }
  }

  static async GET_PRINTER_SETTINGS_DATA(params, token = "") {
    try {
      const query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);

      const res = await axios.get(
        process.env.REACT_APP_API_BASE_URL + `/v1/admin/print-service/printer-settings${query}`,
        { headers },
      );

      return res.data;
    } catch (err) {
      return err.response.data;
    }
  }

  /**
   * QZ tray
   *
   * @param {*} reqBody
   * @param {*} token
   * @returns
   */
  static async QZ_TRAY_MESSAGE_SIGN_IN(reqBody, token = "") {
    try {
      const headers = this.getAuthHeader(token);

      // Send the request with params in the body
      const res = await axios.post(
        process.env.REACT_APP_API_BASE_URL + "/v1/admin/print-service/qz-tray-signin",
        reqBody,
        {
          headers,
        },
      );
      return res.data;
    } catch (err) {
      return err.response.data;
    }
  }

  /**
   * Upsert (create or update) an addition item for a restaurant.
   * @param {Object} reqBody - Data for the addition item (id, restaurantId, name).
   * @param {string} token - Auth token.
   * @returns {Object} API response data or error info.
   */
  static async UPSERT_ADDITION_ITEM(reqBody, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const url = `${process.env.REACT_APP_API_BASE_URL}/v1/admin/addition/item/upsert`;

      const { data } = await axios.post(url, reqBody, { headers });
      return data;
    } catch (error) {
      return error?.response?.data || { message: "An error occurred while upserting addition item." };
    }
  }

  /**
   * Fetch all addition items for a given restaurant.
   * @param {string} restaurantId - Restaurant identifier.
   * @param {string} token - Auth token.
   * @returns {Object} API response with items or error info.
   */
  static async GET_ADDITION_ITEM_LIST(restaurantId, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const url = `${process.env.REACT_APP_API_BASE_URL}/v1/admin/addition/item/list?restaurantId=${encodeURIComponent(
        restaurantId,
      )}`;

      const { data } = await axios.get(url, { headers });
      return data;
    } catch (error) {
      return error?.response?.data || { message: "An error occurred while fetching addition items." };
    }
  }

  /**
   * Delete an addition item by its ID.
   * @param {string} additionItemId - The ID of the addition item to delete.
   * @param {string} token - Auth token.
   * @returns {Object} API response or error info.
   */
  static async DELETE_ADDITION_ITEM(additionItemId, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const url = `${process.env.REACT_APP_API_BASE_URL}/v1/admin/addition/item/${encodeURIComponent(
        additionItemId,
      )}/delete`;

      const { data } = await axios.delete(url, { headers });
      return data;
    } catch (error) {
      return error?.response?.data || { message: "Error while deleting addition item." };
    }
  }

  /**
   * Confirm deletion of an addition item (with dependencies).
   * @param {Object} reqBody - Data for confirm deletion:
   *   - additionItemId {string}: ID of the item.
   *   - dependentFoods {Array<string>}: IDs of dependent foods.
   *   - dependentSetMenus {Array<string>}: IDs of dependent set menus.
   * @param {string} token - Auth token.
   * @returns {Object} API response or error info.
   */
  static async CONFIRM_DELETE_ADDITION_ITEM(reqBody, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const url = `${process.env.REACT_APP_API_BASE_URL}/v1/admin/addition/item/delete/confirm`;

      const { data } = await axios.delete(url, { data: reqBody, headers });
      return data;
    } catch (error) {
      return error?.response?.data || { message: "Error while confirming deletion of addition item." };
    }
  }

  static async GET_LOYALTY_MEMBERSHIP(params, token = "") {
    try {
      const query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);

      const res = await axios.get(process.env.REACT_APP_API_BASE_URL + `/v1/admin/loyalty/member/get${query}`, {
        headers,
      });

      return res.data;
    } catch (err) {
      return err.response.data;
    }
  }

  static async ADD_LOYALTY_MEMBERSHIP(params, token = "") {
    try {
      const reqBody = { ...params };
      const headers = this.getAuthHeader(token);
      const url = `${process.env.REACT_APP_API_BASE_URL}/v1/admin/loyalty/member/add`;

      const { data } = await axios.post(url, reqBody, { headers });
      return data;
    } catch (error) {
      return error?.response?.data || { message: "An error occurred while adding membership" };
    }
  }

  static async GET_FLOOR_AND_TABLE_LAYOUT(params, token = "") {
    try {
      let query = getStructuredQueryParam(params);
      const headers = this.getAuthHeader(token);
      const res = await axios.get(
        process.env.REACT_APP_API_BASE_URL + `/v1/admin/table-management/floor-and-table/get` + query,
        {
          headers,
        },
      );
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async ADD_OR_EDIT_FLOOR_NAME(params, token = "") {
    try {
      const reqBody = { ...params };
      const headers = this.getAuthHeader(token);
      const url = `${process.env.REACT_APP_API_BASE_URL}/v1/admin/table-management/floor/upsert`;

      const { data } = await axios.post(url, reqBody, { headers });
      return data;
    } catch (error) {
      return error?.response?.data || { message: "An error occurred while adding membership" };
    }
  }

  static async DELETE_FLOOR_NAME(params, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.delete(process.env.REACT_APP_API_BASE_URL + `/v1/admin/table-management/floor/delete`, {
        headers: { ...headers },
        data: { ...params },
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async ADD_TABLE_TO_FLOOR(params, token = "") {
    try {
      const reqBody = { ...params };
      const headers = this.getAuthHeader(token);
      const url = `${process.env.REACT_APP_API_BASE_URL}/v1/admin/table-management/floor/table/upsert`;

      const { data } = await axios.post(url, reqBody, { headers });
      return data;
    } catch (error) {
      return error?.response?.data || { message: "An error occurred while adding membership" };
    }
  }

  static async TABLE_CLEAN(params, token = "") {
    try {
      const reqBody = { ...params };
      const headers = this.getAuthHeader(token);
      const url = `${process.env.REACT_APP_API_BASE_URL}/v1/admin/table-management/table/clean`;

      const { data } = await axios.patch(url, reqBody, { headers });
      return data;
    } catch (error) {
      return error?.response?.data || { message: "An error occurred while cleaning table" };
    }
  }

  static async FETCH_SPLITTED_DETAILS(orderId, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.get(
        process.env.REACT_APP_API_BASE_URL + `/v1/admin/table-management/order/split/get?orderId=${orderId}`,
        {
          headers,
        },
      );
      return res.data;
    } catch (err) {
      return err.response;
    }
  }

  static async SPLIT_BILL(params, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.post(
        process.env.REACT_APP_API_BASE_URL + "/v1/admin/table-management/order/split/save",
        params,
        { headers },
      );
      return res.data;
    } catch (err) {
      console.log("----split order---", { err, "err.response.data": err.response.data });
      return err.response.data;
    }
  }

  static async MERGE_ORDER(params, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.post(
        process.env.REACT_APP_API_BASE_URL + "/v1/admin/table-management/order/merge",
        params,
        { headers },
      );
      return res.data;
    } catch (err) {
      console.log("----merge order---", { err, "err.response.data": err.response.data });
      return err.response.data;
    }
  }

  static async TRANSFER_ORDER(params, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.patch(
        process.env.REACT_APP_API_BASE_URL + "/v1/admin/table-management/order/transfer-table",
        params,
        { headers },
      );
      return res.data;
    } catch (err) {
      console.log("----transfer order---", { err, "err.response.data": err.response.data });
      return err.response.data;
    }
  }

  static async UPDATE_GUESTS(params, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.patch(
        process.env.REACT_APP_API_BASE_URL + "/v1/admin/table-management/order/update-guest",
        params,
        { headers },
      );
      return res.data;
    } catch (err) {
      console.log("----transfer order---", { err, "err.response.data": err.response.data });
      return err.response.data;
    }
  }

  static async DELETE_ORDER(orderId, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const res = await axios.patch(
        process.env.REACT_APP_API_BASE_URL + `/v1/super-admin/order/${orderId}/cancel`,
        {},
        { headers },
      );
      return res.data;
    } catch (err) {
      console.log("----delete order---", { err, "err.response.data": err.response.data });
      return err.response.data;
    }
  }

  /**
   * Fetch all addition items for a given restaurant.
   * @param {string} restaurantId - Restaurant identifier.
   * @param {string} token - Auth token.
   * @returns {Object} API response with items or error info.
   */
  static async GET_COUPON_DROPDOWN(restaurantId, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const url = `${process.env.REACT_APP_API_BASE_URL}/v1/admin/coupon-management/coupon/dropdown?status=Active&restaurantId=${encodeURIComponent(
        restaurantId,
      )}`;

      const { data } = await axios.get(url, { headers });
      return data;
    } catch (error) {
      return error?.response?.data || { message: "An error occurred while fetching addition items." };
    }
  }

  static async APPLY_COUPON(params, token = "") {
    try {
      const headers = this.getAuthHeader(token);
      const { data } = await axios.post(
        process.env.REACT_APP_API_BASE_URL + "/v1/common/coupon/verify",
        params,
        { headers }
      );
      
      return data;
    } catch (err) {
      console.log("----transfer order---", { err, "err.response.data": err.response.data });
      return err.response.data;
    }
  }
}
